import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupModule } from '@rd/popup/popup.module';
import { OfferTerms } from '@rd/types';

@Component({
  selector: 'rd-offer-terms-and-conditions-dialog',
  templateUrl: './terms-and-conditions-dialog.component.html',
  styleUrls: ['./terms-and-conditions-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PopupModule, TranslateModule],
})
export class OfferTermsAndConditionsDialogComponent {
  @HostBinding('class.rd-offer-terms-and-conditions-dialog')
  componentClass = true;

  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig<{ content: OfferTerms[] }>,
  ) {}

  closeModal(): void {
    this.dialogRef.close();
  }

  getTermsAndConditionContent(): OfferTerms[] {
    return this.dialogConfig.data?.content ?? [];
  }
}
